var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: this.transitionName } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.state,
                expression: "!state"
              }
            ]
          },
          [_vm._t("placeholder")],
          2
        )
      ]),
      _c("transition", { attrs: { name: this.transitionName } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.state === "loaded",
                expression: "state === 'loaded'"
              }
            ]
          },
          [_vm._t("main")],
          2
        )
      ]),
      _c("transition", { attrs: { name: this.transitionName } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.state === "error",
                expression: "state === 'error'"
              }
            ]
          },
          [_vm._t("error")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }